/* ATP Plant: on add to cart, the product image shrinks into a seed, drops into soil and an olive sprout grows.
   Called by atp.js (window.atpPlant). Returns true when it handled the moment, so the old fly-to-cart is skipped. */
(function () {
  'use strict';
  var w = window, d = document;
  var NOTE = 'This order will plant an olive tree';
  var leaf = 'M0 0 Q 9 -4.4 19 0 Q 9 4.4 0 0 Z';
  // stem runs from the soil (0,4) up to (1,-44); leaves sit along it
  var LEAVES = [
    { x: 0.4, y: -10, r: -24, s: 0.75, under: false, d: 0.98 },
    { x: 0.1, y: -16, r: 206, s: 0.85, under: true, d: 1.04 },
    { x: -0.6, y: -24, r: -34, s: 1, under: false, d: 1.1 },
    { x: -0.5, y: -29, r: 200, s: 0.95, under: false, d: 1.16 },
    { x: 0.1, y: -36, r: -46, s: 0.9, under: true, d: 1.22 },
    { x: 0.6, y: -40, r: 190, s: 0.8, under: false, d: 1.28 },
    { x: 1, y: -44, r: -80, s: 0.72, under: false, d: 1.34 }
  ];

  function svg() {
    var leaves = LEAVES.map(function (l) {
      return '<g transform="translate(' + l.x + ' ' + l.y + ') rotate(' + l.r + ') scale(' + l.s + ')"><g class="atp-plant__leaf' + (l.under ? ' is-under' : '') + '" style="--d:' + l.d + 's"><path d="' + leaf + '"/></g></g>';
    }).join('');
    return '<svg class="atp-plant__svg" viewBox="-40 -70 80 90" aria-hidden="true">' +
      '<ellipse class="atp-plant__soil" cx="0" cy="8" rx="30" ry="9"/>' +
      '<ellipse class="atp-plant__soil-hi" cx="-4" cy="5.5" rx="16" ry="4"/>' +
      '<g class="atp-plant__sprout"><path class="atp-plant__stem" pathLength="1" d="M0 5 C 1.5 -10, -2 -26, 1 -44"/>' + leaves + '</g></svg>';
  }

  function findImage(form) {
    var scope = form && (form.closest('.quick-add-modal, .main-product--section, .shopify-section, section') || d);
    if (!scope) return null;
    return Array.prototype.filter.call(scope.querySelectorAll('img'), function (i) {
      var r = i.getBoundingClientRect(); return r.width > 60 && r.bottom > 0 && r.top < w.innerHeight;
    })[0] || null;
  }

  function landing(a) {
    var vw = w.innerWidth, vh = w.innerHeight;
    if (vw < 750 || !a) return { x: vw / 2, y: vh * 0.42 };
    var drawer = d.querySelector('cart-drawer .drawer__inner');
    var edge = vw;
    if (drawer) { var r = drawer.getBoundingClientRect(); if (r.width && r.left > 0 && r.left < vw) edge = r.left; }
    var x = Math.max(170, Math.min(a.left + a.width / 2, edge - 170));
    var y = Math.max(190, Math.min(a.top + a.height / 2 + 30, vh - 140));
    return { x: x, y: y };
  }

  w.atpPlant = function (form, done) {
    var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var img = findImage(form);
    var a = img ? img.getBoundingClientRect() : null;
    var at = landing(a);

    var stage = d.createElement('div');
    stage.className = 'atp-plant';
    stage.setAttribute('role', 'status');
    stage.style.left = at.x + 'px'; stage.style.top = at.y + 'px';
    stage.innerHTML = '<div class="atp-plant__glow"></div>' + svg() + '<p class="atp-plant__note">' + NOTE + '</p>';
    d.body.appendChild(stage);

    var finish = function () {
      stage.classList.add('is-out');
      setTimeout(function () { stage.remove(); }, 700);
      if (done) done();
    };

    if (reduce || !stage.animate || !img) {
      stage.classList.add(reduce ? 'is-still' : 'is-go');
      setTimeout(finish, reduce ? 2200 : 3000);
      return true;
    }

    // the product image lifts off and shrinks into a seed that drops into the soil
    var size = Math.min(150, a.width);
    var seed = d.createElement('div');
    seed.className = 'atp-plant-seed';
    seed.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
    var clone = new Image(); clone.src = img.currentSrc || img.src; clone.alt = '';
    var tint = d.createElement('i');
    seed.appendChild(clone); seed.appendChild(tint); d.body.appendChild(seed);
    var dx = at.x - (a.left + a.width / 2), dy = at.y + 6 - (a.top + a.height / 2);
    var k = 18 / size;
    seed.animate([
      { transform: 'translate3d(0,0,0) scale(1)', borderRadius: '14px', opacity: 1 },
      { transform: 'translate3d(' + dx * 0.5 + 'px,' + (dy * 0.5 - 70) + 'px,0) scale(' + Math.max(k * 3, 0.35) + ')', borderRadius: '40%', opacity: 1, offset: 0.55 },
      { transform: 'translate3d(' + dx + 'px,' + (dy - 6) + 'px,0) scale(' + k + ',' + k * 1.35 + ')', borderRadius: '50%', opacity: 1, offset: 0.88 },
      { transform: 'translate3d(' + dx + 'px,' + (dy + 2) + 'px,0) scale(' + k * 0.8 + ')', borderRadius: '50%', opacity: 0 }
    ], { duration: 780, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' });
    tint.animate([{ opacity: 0 }, { opacity: 0, offset: 0.35 }, { opacity: 1 }], { duration: 700, fill: 'forwards' });
    setTimeout(function () { seed.remove(); }, 820);

    stage.classList.add('is-go');
    setTimeout(finish, 3000);
    return true;
  };
})();
